{
  "lifecycle.title": "التعيين وإنهاء الخدمة",
  "lifecycle.kind.onboarding": "تعيين",
  "lifecycle.kind.offboarding": "إنهاء خدمة",
  "lifecycle.owner.hr": "الموارد البشرية",
  "lifecycle.owner.manager": "المدير المباشر",
  "lifecycle.owner.employee": "الموظف",
  "lifecycle.owner.it": "الدعم الفني",
  "lifecycle.due.overdue": "كان موعدها {date}",
  "lifecycle.due.today": "موعدها اليوم",
  "lifecycle.due.upcoming": "موعدها {date}",
  "lifecycle.offset.onboarding.before": "{days, plural, one {قبل أول يوم عمل بيوم} two {قبل أول يوم عمل بيومين} few {قبل أول يوم عمل بـ# أيام} many {قبل أول يوم عمل بـ# يومًا} other {قبل أول يوم عمل بـ# يوم}}",
  "lifecycle.offset.onboarding.on": "في أول يوم عمل",
  "lifecycle.offset.onboarding.after": "{days, plural, one {بعد أول يوم عمل بيوم} two {بعد أول يوم عمل بيومين} few {بعد أول يوم عمل بـ# أيام} many {بعد أول يوم عمل بـ# يومًا} other {بعد أول يوم عمل بـ# يوم}}",
  "lifecycle.offset.offboarding.before": "{days, plural, one {قبل آخر يوم عمل بيوم} two {قبل آخر يوم عمل بيومين} few {قبل آخر يوم عمل بـ# أيام} many {قبل آخر يوم عمل بـ# يومًا} other {قبل آخر يوم عمل بـ# يوم}}",
  "lifecycle.offset.offboarding.on": "في آخر يوم عمل",
  "lifecycle.offset.offboarding.after": "{days, plural, one {بعد آخر يوم عمل بيوم} two {بعد آخر يوم عمل بيومين} few {بعد آخر يوم عمل بـ# أيام} many {بعد آخر يوم عمل بـ# يومًا} other {بعد آخر يوم عمل بـ# يوم}}",
  "lifecycle.startsOn.onboarding": "أول يوم عمل: {date}",
  "lifecycle.startsOn.offboarding": "آخر يوم عمل: {date}",
  "lifecycle.item.doneBy": "أنجزها {name} · {when}",
  "lifecycle.item.doneAt": "أُنجزت · {when}",
  "lifecycle.items.label": "مهام {name}",
  "lifecycle.progress.done": "تم {done} من {total}",
  "lifecycle.progress.overdue": "{count, plural, one {مهمة متأخرة} two {مهمتان متأخرتان} few {# مهام متأخرة} many {# مهمة متأخرة} other {# مهمة متأخرة}}",
  "lifecycle.tick.conflict": "شخص آخر عدّل هذه المهمة في نفس الوقت، وتظهر القائمة الآن بتعديله.",
  "lifecycle.links.checklists": "عروض التعيين وإنهاء الخدمة",
  "lifecycle.links.letters": "عروض الخطابات",
  "lifecycle.links.open": "القوائم المفتوحة",
  "lifecycle.links.requests": "الطلبات",
  "lifecycle.links.templates": "النماذج",
  "lifecycle.board.title": "التعيين وإنهاء الخدمة",
  "lifecycle.board.description": "كل قوائم مهام التعيين وإنهاء الخدمة التي لم تكتمل بعد. افتح أي قائمة لتعليم مهامها.",
  "lifecycle.board.column.onboarding": "المنضمون",
  "lifecycle.board.column.offboarding": "المغادرون",
  "lifecycle.board.columnEmpty.onboarding": "لا أحد ينضم حاليًا.",
  "lifecycle.board.columnEmpty.offboarding": "لا أحد يغادر حاليًا.",
  "lifecycle.board.day.onboarding": "أول يوم",
  "lifecycle.board.day.offboarding": "آخر يوم",
  "lifecycle.board.open": "فتح {title} لـ{name}",
  "lifecycle.board.openProfile": "فتح ملفه الوظيفي",
  "lifecycle.board.unknownPerson": "زميل سابق",
  "lifecycle.board.loadError": "تعذّر تحميل قوائم المهام",
  "lifecycle.board.empty.title": "لا أحد ينضم أو يغادر حاليًا",
  "lifecycle.board.empty.body": "عند انضمام أحد أو مغادرته ابدأ له قائمة مهام، وستظهر هنا حتى تكتمل كل مهامها.",
  "lifecycle.board.toDirectory": "الذهاب إلى دليل الموظفين",
  "lifecycle.start.open": "بدء قائمة مهام",
  "lifecycle.start.title": "بدء قائمة مهام",
  "lifecycle.start.titleFor": "بدء قائمة مهام لـ{name}",
  "lifecycle.start.template": "النموذج",
  "lifecycle.start.date.onboarding": "أول يوم عمل",
  "lifecycle.start.date.offboarding": "آخر يوم عمل",
  "lifecycle.start.dateHint.onboarding": "تُحسب مواعيد المهام من هذا اليوم، ويبدأ بتاريخ التعيين.",
  "lifecycle.start.dateHint.offboarding": "تُحسب مواعيد المهام من هذا اليوم، ويبدأ بآخر يوم عمل المسجّل في الملف.",
  "lifecycle.start.preview": "{count, plural, one {ستُنشأ مهمة واحدة} two {ستُنشأ مهمتان} few {ستُنشأ # مهام} many {ستُنشأ # مهمة} other {ستُنشأ # مهمة}}",
  "lifecycle.start.previewLabel": "المهام ومواعيدها",
  "lifecycle.start.submit": "بدء القائمة",
  "lifecycle.start.started": "بدأت قائمة المهام لـ{name}.",
  "lifecycle.start.noTemplates": "لا يوجد نموذج قائمة مهام متاح حتى الآن.",
  "lifecycle.start.toTemplates": "إنشاء نموذج",
  "lifecycle.pick.description": "اختر الموظف، وسيُفتح ملفه الوظيفي جاهزًا لبدء القائمة.",
  "lifecycle.pick.person": "الموظف",
  "lifecycle.pick.placeholder": "اختر موظفًا",
  "lifecycle.pick.search": "ابحث بالاسم أو البريد أو الكود",
  "lifecycle.pick.empty": "لا أحد يطابق البحث.",
  "lifecycle.pick.continue": "متابعة",
  "lifecycle.checklists.title": "قوائم المهام",
  "lifecycle.checklists.description": "مهام تعيين {name} أو إنهاء خدمته.",
  "lifecycle.checklists.loadError": "تعذّر تحميل قوائم المهام",
  "lifecycle.checklists.empty.title": "لا توجد قوائم مهام بعد",
  "lifecycle.checklists.empty.body": "ابدأ قائمة تعيين عند انضمام {name}، أو قائمة إنهاء خدمة عند مغادرته.",
  "lifecycle.checklists.empty.readOnly": "لم تبدأ الموارد البشرية قائمة مهام لـ{name}.",
  "lifecycle.templates.title": "نماذج قوائم المهام",
  "lifecycle.templates.description": "المهام التي يمر بها كل منضم أو مغادر، ومن يتولى كل مهمة، وموعدها.",
  "lifecycle.templates.new": "نموذج جديد",
  "lifecycle.templates.loadError": "تعذّر تحميل النماذج",
  "lifecycle.templates.empty.title": "لا توجد نماذج بعد",
  "lifecycle.templates.empty.body": "اكتب خطوات استقبال موظف جديد أو توديع موظف مرة واحدة، ثم ابدأها لكل شخص بضغطة.",
  "lifecycle.templates.group.onboarding": "التعيين",
  "lifecycle.templates.group.offboarding": "إنهاء الخدمة",
  "lifecycle.templates.taskCount": "{count, plural, zero {بلا مهام} one {مهمة واحدة} two {مهمتان} few {# مهام} many {# مهمة} other {# مهمة}}",
  "lifecycle.templates.retired": "غير متاح",
  "lifecycle.templates.showTasks": "عرض المهام",
  "lifecycle.templates.edit": "تعديل",
  "lifecycle.templates.editNamed": "تعديل {name}",
  "lifecycle.editor.newTitle": "نموذج قائمة مهام جديد",
  "lifecycle.editor.editTitle": "تعديل نموذج قائمة المهام",
  "lifecycle.editor.name": "الاسم",
  "lifecycle.editor.namePlaceholder": "استقبال موظف جديد",
  "lifecycle.editor.nameMissing": "اكتب اسمًا للنموذج.",
  "lifecycle.editor.kind": "النوع",
  "lifecycle.editor.kindHint.onboarding": "المواعيد تُحسب من أول يوم عمل",
  "lifecycle.editor.kindHint.offboarding": "المواعيد تُحسب من آخر يوم عمل",
  "lifecycle.editor.active": "متاح عند بدء قائمة مهام",
  "lifecycle.editor.activeHint": "القوائم التي بدأت بالفعل تحتفظ بمهامها في كل الأحوال.",
  "lifecycle.editor.tasks": "المهام",
  "lifecycle.editor.tasksHint.onboarding": "بالترتيب، وموعد كل مهمة بعدد أيام من أول يوم عمل.",
  "lifecycle.editor.tasksHint.offboarding": "بالترتيب، وموعد كل مهمة بعدد أيام من آخر يوم عمل.",
  "lifecycle.editor.noTasks": "أضف مهمة واحدة على الأقل.",
  "lifecycle.editor.titleLabel": "المهمة {number}: المطلوب",
  "lifecycle.editor.titlePlaceholder": "تجهيز اللابتوب والحسابات",
  "lifecycle.editor.titleMissing": "اكتب المطلوب في هذه المهمة.",
  "lifecycle.editor.ownerLabel": "المهمة {number}: المسؤول عنها",
  "lifecycle.editor.daysLabel": "المهمة {number}: عدد الأيام",
  "lifecycle.editor.relationLabel": "المهمة {number}: التوقيت",
  "lifecycle.editor.days": "{count, plural, zero {يوم} one {يوم} two {يوم} few {أيام} many {يومًا} other {يوم}}",
  "lifecycle.editor.relation.onboarding.before": "قبل أول يوم عمل",
  "lifecycle.editor.relation.onboarding.on": "في أول يوم عمل",
  "lifecycle.editor.relation.onboarding.after": "بعد أول يوم عمل",
  "lifecycle.editor.relation.offboarding.before": "قبل آخر يوم عمل",
  "lifecycle.editor.relation.offboarding.on": "في آخر يوم عمل",
  "lifecycle.editor.relation.offboarding.after": "بعد آخر يوم عمل",
  "lifecycle.editor.daysRange": "حتى ٩٠ يومًا قبله أو ١٨٠ يومًا بعده.",
  "lifecycle.editor.moveUp": "تحريك المهمة {number} لأعلى",
  "lifecycle.editor.moveDown": "تحريك المهمة {number} لأسفل",
  "lifecycle.editor.remove": "حذف المهمة {number}",
  "lifecycle.editor.moved": "انتقلت {title} إلى الترتيب {position} من {total}.",
  "lifecycle.editor.untitled": "مهمة بلا عنوان",
  "lifecycle.editor.addTask": "إضافة مهمة",
  "lifecycle.editor.save": "حفظ النموذج",
  "lifecycle.editor.saved": "حُفظ {name}.",
  "lifecycle.category.laptop": "لابتوب",
  "lifecycle.category.phone": "موبايل",
  "lifecycle.category.tablet": "تابلت",
  "lifecycle.category.monitor": "شاشة",
  "lifecycle.category.key_card": "كارت دخول",
  "lifecycle.category.other": "أخرى",
  "lifecycle.assetStatus.available": "متاحة",
  "lifecycle.assetStatus.assigned": "مُسلَّمة",
  "lifecycle.assetStatus.maintenance": "في الصيانة",
  "lifecycle.assetStatus.retired": "خارج الخدمة",
  "lifecycle.register.title": "سجل العُهد",
  "lifecycle.register.description": "كل جهاز وكارت تسلّمه الشركة، ومع مَن، ومنذ متى.",
  "lifecycle.register.caption": "سجل العُهد",
  "lifecycle.register.add": "إضافة عهدة",
  "lifecycle.register.editNamed": "تعديل {title}",
  "lifecycle.register.loadError": "تعذّر تحميل سجل العُهد",
  "lifecycle.register.empty.title": "سجل العُهد فارغ",
  "lifecycle.register.empty.body": "أضف اللابتوبات والموبايلات وكروت الدخول التي تسلّمها الشركة، ثم سجّل مع مَن كل واحدة.",
  "lifecycle.register.statusFilter": "التصفية حسب الحالة",
  "lifecycle.register.all": "الكل",
  "lifecycle.register.categoryFilter": "التصفية حسب النوع",
  "lifecycle.register.allCategories": "كل الأنواع",
  "lifecycle.register.search": "ابحث في العُهد",
  "lifecycle.register.noMatch.title": "لا نتائج",
  "lifecycle.register.noMatch.body": "جرّب بحثًا آخر أو امسح عوامل التصفية.",
  "lifecycle.register.clear": "مسح عوامل التصفية",
  "lifecycle.register.columns.name": "العهدة",
  "lifecycle.register.columns.category": "النوع",
  "lifecycle.register.columns.serial": "الرقم التسلسلي",
  "lifecycle.register.columns.status": "حالة العهدة",
  "lifecycle.register.columns.holder": "مع",
  "lifecycle.register.columns.since": "منذ",
  "lifecycle.register.columns.actions": "إجراءات",
  "lifecycle.assetForm.name": "الاسم",
  "lifecycle.assetForm.namePlaceholder": "MacBook Pro 14",
  "lifecycle.assetForm.nameMissing": "اكتب اسمًا للعهدة.",
  "lifecycle.assetForm.category": "النوع",
  "lifecycle.assetForm.customCategory": "نوع آخر…",
  "lifecycle.assetForm.customLabel": "أي نوع",
  "lifecycle.assetForm.customPlaceholder": "كاميرا",
  "lifecycle.assetForm.categoryMissing": "اكتب نوع العهدة.",
  "lifecycle.assetForm.serial": "الرقم التسلسلي",
  "lifecycle.assetForm.purchasedOn": "تاريخ الشراء",
  "lifecycle.assetForm.status": "حالة العهدة",
  "lifecycle.assetForm.assignedNote": "العهدة مع {name}. استلمها أولًا لتغيير حالتها.",
  "lifecycle.assetForm.notes": "ملاحظات",
  "lifecycle.assetForm.create": "إضافة العهدة",
  "lifecycle.assetForm.save": "حفظ التعديلات",
  "lifecycle.assetForm.added": "أُضيفت {title} إلى سجل العُهد.",
  "lifecycle.assetForm.saved": "حُفظت {title}.",
  "lifecycle.handover.open": "تسليم عهدة",
  "lifecycle.handover.short": "تسليم",
  "lifecycle.handover.openFor": "تسليم {title}",
  "lifecycle.handover.titleAsset": "تسليم {title}",
  "lifecycle.handover.titlePerson": "تسليم عهدة إلى {name}",
  "lifecycle.handover.asset": "العهدة",
  "lifecycle.handover.assetPlaceholder": "اختر عهدة متاحة",
  "lifecycle.handover.assetMissing": "اختر العهدة.",
  "lifecycle.handover.noneAvailable": "لا توجد عهدة متاحة الآن. أضف واحدة إلى السجل أو استلم واحدة أولًا.",
  "lifecycle.handover.person": "تُسلَّم إلى",
  "lifecycle.handover.personMissing": "اختر مستلم العهدة.",
  "lifecycle.handover.on": "تاريخ التسليم",
  "lifecycle.handover.condition": "حالة العهدة عند التسليم",
  "lifecycle.handover.conditionHint": "اختياري: خدوش، ملحقات مرفقة، أي شيء يُراجع عند الاستلام.",
  "lifecycle.handover.submit": "تسليم",
  "lifecycle.handover.done": "سُلّمت {title} إلى {name}.",
  "lifecycle.giveBack.open": "استلام",
  "lifecycle.giveBack.openFor": "استلام {title}",
  "lifecycle.giveBack.title": "استلام {title}",
  "lifecycle.giveBack.since": "العهدة مع {name} منذ {date}.",
  "lifecycle.giveBack.holder": "العهدة مع {name}.",
  "lifecycle.giveBack.on": "تاريخ الاستلام",
  "lifecycle.giveBack.condition": "حالة العهدة عند الاستلام",
  "lifecycle.giveBack.conditionHint": "اختياري: سجّل أي تلف أو أجزاء ناقصة.",
  "lifecycle.giveBack.submit": "استلام",
  "lifecycle.giveBack.done": "استُلمت {title} وأصبحت متاحة.",
  "lifecycle.assets.heldTitle": "العُهد التي معه",
  "lifecycle.assets.heldDescription": "ما تسلّمه {name} من الشركة، ومنذ متى.",
  "lifecycle.assets.heldBy": "العُهد التي مع {name}",
  "lifecycle.assets.loadError": "تعذّر تحميل العُهد",
  "lifecycle.assets.heldEmpty.title": "لا عُهد",
  "lifecycle.assets.heldEmpty.body": "لا توجد مع {name} أي عهدة من الشركة.",
  "lifecycle.assets.since": "منذ {date}",
  "lifecycle.leaver.leaving": "آخر يوم عمل لـ{name} هو {date}",
  "lifecycle.leaver.left": "ترك {name} العمل في {date}",
  "lifecycle.leaver.stillHeld": "{count, plural, one {ما زالت معه عهدة واحدة} two {ما زالت معه عهدتان} few {ما زالت معه # عُهد} many {ما زالت معه # عهدة} other {ما زالت معه # عهدة}}. استلمها قبل التسوية النهائية.",
  "lifecycle.leaver.allBack": "استُلمت كل العُهد.",
  "lifecycle.leaver.settlement": "التسوية النهائية",
  "lifecycle.letterStatus.pending": "بانتظار الموافقة",
  "lifecycle.letterStatus.approved": "صدر",
  "lifecycle.letterStatus.rejected": "مرفوض",
  "lifecycle.letterStatus.cancelled": "مسحوب",
  "lifecycle.language.ar": "العربية",
  "lifecycle.language.en": "الإنجليزية",
  "lifecycle.letters.title": "طلبات الخطابات",
  "lifecycle.letters.description": "كل الخطابات التي طلبها الموظفون. القرارات عادةً من صفحة الطلبات؛ افتح أي خطاب لقراءته أو طباعته.",
  "lifecycle.letters.caption": "طلبات الخطابات",
  "lifecycle.letters.loadError": "تعذّر تحميل طلبات الخطابات",
  "lifecycle.letters.empty.title": "لا توجد طلبات خطابات بعد",
  "lifecycle.letters.empty.body": "عندما يطلب أحد شهادة عمل أو شهادة خبرة من ملفه الوظيفي، يظهر طلبه هنا.",
  "lifecycle.letters.statusFilter": "التصفية حسب الحالة",
  "lifecycle.letters.search": "ابحث بالموظف أو الخطاب",
  "lifecycle.letters.noMatch": "لا يوجد خطاب مطابق",
  "lifecycle.letters.columns.letter": "الخطاب",
  "lifecycle.letters.columns.employee": "الموظف",
  "lifecycle.letters.columns.addressee": "موجّه إلى",
  "lifecycle.letters.columns.requested": "تاريخ الطلب",
  "lifecycle.letters.columns.status": "الحالة",
  "lifecycle.letters.toWhom": "من يهمه الأمر",
  "lifecycle.letter.toWhomLabel": "إلى من يهمه الأمر",
  "lifecycle.letter.back": "كل الخطابات",
  "lifecycle.letter.loadError": "تعذّر تحميل هذا الخطاب",
  "lifecycle.letter.missing.title": "هذا الخطاب غير موجود",
  "lifecycle.letter.missing.body": "ربما حُذف، أو الرابط غير صحيح.",
  "lifecycle.letter.requestTitle": "الطلب",
  "lifecycle.letter.employee": "الموظف",
  "lifecycle.letter.language": "اللغة",
  "lifecycle.letter.addressee": "موجّه إلى",
  "lifecycle.letter.purpose": "الغرض",
  "lifecycle.letter.requested": "تاريخ الطلب",
  "lifecycle.letter.print": "طباعة",
  "lifecycle.letter.copy": "نسخ النص",
  "lifecycle.notIssued.title.pending": "بانتظار الموافقة",
  "lifecycle.notIssued.title.rejected": "رُفض الطلب",
  "lifecycle.notIssued.title.cancelled": "سُحب الطلب",
  "lifecycle.notIssued.body.pending": "سيظهر الخطاب هنا جاهزًا للطباعة بعد الموافقة عليه.",
  "lifecycle.notIssued.body.rejected": "لن يصدر هذا الخطاب.",
  "lifecycle.notIssued.body.cancelled": "سُحب الطلب، فلم يصدر خطاب.",
  "lifecycle.notIssued.waitingOn": "بانتظار موافقة {name}.",
  "lifecycle.notIssued.waitingOnHr": "بانتظار موافقة الموارد البشرية.",
  "lifecycle.flow.title": "الموافقات",
  "lifecycle.flow.label": "مراحل الموافقة",
  "lifecycle.flow.requested": "قُدّم الطلب",
  "lifecycle.flow.withdrawn": "سُحب الطلب",
  "lifecycle.flow.role.manager": "المدير المباشر",
  "lifecycle.flow.role.hr": "الموارد البشرية",
  "lifecycle.flow.state.waiting": "لم يحن دورها",
  "lifecycle.flow.state.current": "بانتظار القرار",
  "lifecycle.flow.state.approved": "تمت الموافقة",
  "lifecycle.flow.state.rejected": "مرفوض",
  "lifecycle.flow.state.skipped": "غير مطلوبة",
  "lifecycle.flow.decided.approved": "وافق {name} · {when}",
  "lifecycle.flow.decided.rejected": "رفض {name} · {when}",
  "lifecycle.decision.title": "قرارك",
  "lifecycle.decision.description": "هذا الطلب بانتظار قرارك.",
  "lifecycle.decision.approve": "موافقة",
  "lifecycle.decision.reject": "رفض",
  "lifecycle.decision.approveTitle": "الموافقة على خطاب {name}؟",
  "lifecycle.decision.approveBody": "إذا كانت موافقتك هي الأخيرة، يصدر الخطاب ببيانات الملف الوظيفي كما هي اليوم ولا يمكن تعديله بعد ذلك.",
  "lifecycle.decision.rejectTitle": "رفض خطاب {name}؟",
  "lifecycle.decision.rejectBody": "اذكر السبب؛ سيراه الموظف مع طلبه.",
  "lifecycle.decision.issued": "تمت الموافقة وصدر الخطاب.",
  "lifecycle.decision.passed": "تمت الموافقة، وانتقل الطلب إلى المرحلة التالية.",
  "lifecycle.decision.rejected": "رُفض الطلب.",
  "lifecycle.withdraw.open": "سحب الطلب",
  "lifecycle.withdraw.openFor": "سحب طلب {title}",
  "lifecycle.withdraw.title": "سحب طلب {title}؟",
  "lifecycle.withdraw.body": "لن ينتظر الطلب الموافقة بعد الآن، ويمكنك الطلب من جديد في أي وقت.",
  "lifecycle.withdraw.confirm": "سحب الطلب",
  "lifecycle.withdraw.pending": "جارٍ السحب…",
  "lifecycle.withdraw.done": "سُحب الطلب.",
  "lifecycle.ask.open": "طلب خطاب",
  "lifecycle.ask.title": "طلب خطاب",
  "lifecycle.ask.description": "يوافق عليه مديرك المباشر ثم الموارد البشرية، ويظهر هنا جاهزًا للطباعة بعد صدوره. الخطابات لا تذكر راتبك أبدًا.",
  "lifecycle.ask.template": "الخطاب",
  "lifecycle.ask.language": "اللغة",
  "lifecycle.ask.addressee": "موجّه إلى",
  "lifecycle.ask.addresseeHint": "اتركه فارغًا ليُوجَّه «إلى من يهمه الأمر».",
  "lifecycle.ask.addresseePlaceholder": "بنك مصر",
  "lifecycle.ask.purpose": "الغرض من الخطاب",
  "lifecycle.ask.purposeHint": "اختياري: فتح حساب بنكي، تأشيرة، دورة تدريبية…",
  "lifecycle.ask.submit": "إرسال الطلب",
  "lifecycle.ask.sent": "أُرسل الطلب، وسيظهر الخطاب هنا بعد الموافقة عليه.",
  "lifecycle.ask.templatesError": "تعذّر تحميل الخطابات المتاحة. حاول مرة أخرى بعد قليل.",
  "lifecycle.ask.noTemplates": "لم تُعِدّ الموارد البشرية أي خطابات بعد.",
  "lifecycle.me.title": "الخطابات والعُهد",
  "lifecycle.me.back": "خطاباتي",
  "lifecycle.me.tasksTitle": "مهام بانتظارك",
  "lifecycle.me.tasksDescription": "مهام من تعيين زميل أو إنهاء خدمته مطلوبة منك.",
  "lifecycle.me.tasksError": "تعذّر تحميل مهامك",
  "lifecycle.me.lettersTitle": "خطاباتي",
  "lifecycle.me.lettersDescription": "شهادات العمل وشهادات الخبرة التي طلبتها من الموارد البشرية.",
  "lifecycle.me.lettersError": "تعذّر تحميل خطاباتك",
  "lifecycle.me.lettersEmpty.title": "لا توجد خطابات بعد",
  "lifecycle.me.lettersEmpty.body": "تحتاج شهادة لبنك أو سفارة؟ اطلبها من الموارد البشرية من هنا.",
  "lifecycle.me.letterMeta": "{label} · طُلب {date}",
  "lifecycle.me.openLetter": "فتح الخطاب",
  "lifecycle.me.openLetterFor": "فتح الخطاب: {title}",
  "lifecycle.me.assetsTitle": "عُهدي",
  "lifecycle.me.assetsDescription": "ما تسلّمته من الشركة.",
  "lifecycle.me.assetsError": "تعذّر تحميل عُهدك",
  "lifecycle.me.assetsEmpty": "لا توجد معك أي عهدة.",
  "lifecycle.letterTemplates.title": "نماذج الخطابات",
  "lifecycle.letterTemplates.description": "الخطابات التي يمكن للموظفين طلبها، مكتوبة مرة واحدة بالعربية والإنجليزية.",
  "lifecycle.letterTemplates.new": "خطاب جديد",
  "lifecycle.letterTemplates.loadError": "تعذّر تحميل نماذج الخطابات",
  "lifecycle.letterTemplates.empty.title": "لا توجد نماذج خطابات بعد",
  "lifecycle.letterTemplates.empty.body": "اكتب شهادة العمل أو شهادة الخبرة مرة واحدة، ثم يطلبها الموظفون من ملفهم الوظيفي.",
  "lifecycle.letterEditor.newTitle": "نموذج خطاب جديد",
  "lifecycle.letterEditor.editTitle": "تعديل نموذج الخطاب",
  "lifecycle.letterEditor.nameAr": "الاسم بالعربية",
  "lifecycle.letterEditor.nameEn": "الاسم بالإنجليزية",
  "lifecycle.letterEditor.nameMissing": "اكتب الاسم بهذه اللغة.",
  "lifecycle.letterEditor.active": "متاح للطلب",
  "lifecycle.letterEditor.activeHint": "الخطابات الصادرة تبقى كما هي في كل الأحوال.",
  "lifecycle.letterEditor.noPayTitle": "الخطابات لا تذكر الراتب أبدًا",
  "lifecycle.letterEditor.noPayBody": "الراتب والبدلات ليست من الحقول المتاحة، فلا يمكن لأي خطاب أن يكشفها.",
  "lifecycle.letterEditor.bodyLanguage": "نص الخطاب",
  "lifecycle.letterEditor.body.ar": "النص العربي",
  "lifecycle.letterEditor.body.en": "النص الإنجليزي",
  "lifecycle.letterEditor.bodyMissing": "اكتب الخطاب بهذه اللغة أيضًا.",
  "lifecycle.letterEditor.placeholders": "إدراج بيان من الملف الوظيفي",
  "lifecycle.letterEditor.insert": "إدراج {label}",
  "lifecycle.letterEditor.unknownTitle": "هذه الحقول غير معروفة، وستُطبع كما كُتبت:",
  "lifecycle.letterEditor.preview": "معاينة",
  "lifecycle.letterEditor.previewHint": "معاينة ببيانات موظف افتراضي",
  "lifecycle.letterEditor.untitled": "خطاب بلا اسم",
  "lifecycle.letterEditor.save": "حفظ الخطاب",
  "lifecycle.letterEditor.saved": "حُفظ نموذج الخطاب.",
  "lifecycle.placeholder.name": "الاسم",
  "lifecycle.placeholder.employee_code": "كود الموظف",
  "lifecycle.placeholder.title": "المسمى الوظيفي",
  "lifecycle.placeholder.department": "القسم",
  "lifecycle.placeholder.hire_date": "تاريخ التعيين",
  "lifecycle.placeholder.contract_type": "نوع العقد",
  "lifecycle.placeholder.addressee": "الجهة الموجّه إليها",
  "lifecycle.placeholder.today": "تاريخ اليوم",
  "lifecycle.sample.name": "منى عادل",
  "lifecycle.sample.title": "مصممة أولى",
  "lifecycle.sample.department": "التصميم",
  "lifecycle.paper.date": "التاريخ",
  "lifecycle.paper.department": "إدارة الموارد البشرية",
  "lifecycle.paper.signedFor": "عن 404 Creative",
  "lifecycle.paper.signature": "التوقيع والختم",
  "lifecycle.errors.serialTaken": "يوجد عهدة أخرى بنفس الرقم التسلسلي.",
  "lifecycle.errors.assetUnavailable": "هذه العهدة مع شخص آخر، أو في الصيانة، أو خارج الخدمة.",
  "lifecycle.errors.assetNotFound": "تعذّر العثور على هذه العهدة؛ ربما حُذفت.",
  "lifecycle.errors.checklistNotFound": "تعذّر العثور على قائمة المهام، أو المهمة ليست مسندة إليك.",
  "lifecycle.errors.templateNotFound": "تعذّر العثور على هذا النموذج؛ ربما حُذف.",
  "lifecycle.errors.letterTemplateNotFound": "هذا الخطاب لم يعد متاحًا.",
  "lifecycle.errors.letterNotFound": "تعذّر العثور على طلب الخطاب.",
  "lifecycle.errors.noRecord": "لا يوجد ملف وظيفي لهذا الشخص بعد، وعلى الموارد البشرية فتحه أولًا.",
  "lifecycle.errors.requestClosed": "صدر قرار في هذا الطلب أو سُحب بالفعل.",
  "lifecycle.errors.notYourDecision": "هذه المرحلة بانتظار شخص آخر."
}
